// extracted by mini-css-extract-plugin
module.exports = {"root":"Navigation_root__0qaWa","link":"Navigation_link__0cj_Z"};